import { useCallback, useState } from 'react';
import { connect } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './Judgment.module.scss';
import { IKnmErknmFormSubject } from '../MainModule/interfaces/IKnmErknmFormSubject';
import { Row } from '../../UIPackage/FormModule/components/Row';
import { IKnmFormRef } from '../../KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IKnmErknmFormAct } from '../MainModule/interfaces/IKnmErknmFormAct';
import { IKnmErknmFormResultDecision } from '../MainModule/interfaces/IKnmErknmFormResultDecision';
import { IKnmErknmFormJudgment } from '../MainModule/interfaces/IKnmErknmFormJudgment';
import { IKnmErknmFormJudgmentCanceled } from '../MainModule/interfaces/IKnmErknmFormJudgmentCanceled';
import { IKnmErknmFormJudgmentSubjectData } from '../MainModule/interfaces/IKnmErknmFormJudgmentSubjectData';
import { IKnmErknmFormJudgmentActsAndDecisions } from '../MainModule/interfaces/IKnmErknmFormJudgmentActsAndDecisions';
import { IKnmErknmForm } from '../MainModule/interfaces/IKnmErknmForm';

interface ITemplateJudgmentModalElementProps {
  formRef: IKnmFormRef | undefined;
  modalType: 'organization' | 'actsAndDecisions' | 'judgments';
  judgmentItemName?: string;
  judgmentItemSubjectDataItemName?: string;
  organizationToSelect?: IKnmErknmFormSubject;
  actToSelect?: IKnmErknmFormAct;
  decisionToSelect?: IKnmErknmFormResultDecision;
  judgmentToSelect?: IKnmErknmFormJudgment;
}

const JudgmentModalElementWithoutStore = ({
  formRef,
  modalType,
  judgmentItemName,
  judgmentItemSubjectDataItemName,
  organizationToSelect,
  actToSelect,
  decisionToSelect,
  judgmentToSelect,
}: ITemplateJudgmentModalElementProps) => {
  const push = formRef?.current.mutators.push;

  // @ts-ignore
  let judgmentOrganizationList: IKnmErknmFormJudgmentSubjectData[] | undefined = formRef?.current.getFieldState(
    `${judgmentItemName}.judgmentSubjectData` as keyof IKnmErknmForm,
  )?.value;
  // @ts-ignore
  let judgmentActList: IKnmErknmFormJudgmentActsAndDecisions[] | undefined = formRef?.current.getFieldState(
    `${judgmentItemSubjectDataItemName}.cancellationActsAndDecisions` as keyof IKnmErknmForm,
  )?.value;
  // @ts-ignore
  let judgmentDecisionList: IKnmErknmFormJudgmentActsAndDecisions[] | undefined = formRef?.current.getFieldState(
    `${judgmentItemSubjectDataItemName}.cancellationActsAndDecisions` as keyof IKnmErknmForm,
  )?.value;
  // @ts-ignore
  let judgmentCancellationList: IKnmErknmFormJudgmentCanceled[] | undefined = formRef?.current.getFieldState(
    `${judgmentItemName}.canceledJudgments` as keyof IKnmErknmForm,
  )?.value;
  const [isOrganizationActive, setIsOrganizationActive] = useState<boolean>(
    organizationToSelect
      ? organizationToSelect.guid !== undefined &&
          judgmentOrganizationList !== undefined &&
          judgmentOrganizationList?.map(x => x.organizationGuid).includes(organizationToSelect.guid)
      : false,
  );
  const [isActActive, setIsActActive] = useState<boolean>(
    actToSelect
      ? actToSelect.guid !== undefined &&
          actToSelect.guid !== null &&
          judgmentActList !== undefined &&
          judgmentActList?.map(x => x.actGuid).includes(actToSelect.guid)
      : false,
  );
  const [isDecisionActive, setIsDecisionActive] = useState<boolean>(
    decisionToSelect
      ? decisionToSelect.guid !== undefined &&
          decisionToSelect.guid !== null &&
          judgmentDecisionList !== undefined &&
          judgmentDecisionList?.map(x => x.decisionGuid).includes(decisionToSelect.guid)
      : false,
  );

  const [isJudgmentActive, setIsJudgmentActive] = useState<boolean>(
    judgmentToSelect
      ? judgmentToSelect.guid !== undefined &&
          judgmentToSelect.guid !== null &&
          judgmentCancellationList !== undefined &&
          judgmentCancellationList?.map(x => x.guid).includes(judgmentToSelect.guid)
      : false,
  );

  const isItemActive = useCallback(() => {
    if (isOrganizationActive || isActActive || isDecisionActive || isJudgmentActive) {
      return styles.TemplatesItemActive;
    }

    return styles.TemplatesItem;
  }, [isOrganizationActive, isActActive, isDecisionActive, isJudgmentActive]);

  const handleSelect = useCallback(() => {
    if (modalType === 'organization') {
      return handleOrganizationSelectElement();
    }
    if (modalType === 'actsAndDecisions' && actToSelect && actToSelect.guid) {
      return handleActSelectElement();
    }
    if (modalType === 'actsAndDecisions' && decisionToSelect && decisionToSelect.guid) {
      return handleDecisionSelectElement();
    }

    return handleJudgmentSelectElement();
  }, [modalType, actToSelect, decisionToSelect]);

  const handleOrganizationSelectElement = useCallback(() => {
    if (organizationToSelect && organizationToSelect.guid) {
      // @ts-ignore
      judgmentOrganizationList = formRef?.current.getFieldState(
        `${judgmentItemName}.judgmentSubjectData` as keyof IKnmErknmForm,
      )?.value;

      if (!judgmentOrganizationList?.map(x => x.organizationGuid).includes(organizationToSelect.guid) && push) {
        const newSubjectData: IKnmErknmFormJudgmentSubjectData = {
          organizationGuid: organizationToSelect.guid,
          isJudgmentAgainstOrganizations: undefined,
          isJudgmentAgainstOfficialPerson: undefined,
          judgmentAgainstOrganizations: undefined,
          judgmentAgainstOfficialPerson: undefined,
          cancellationActsAndDecisions: undefined,
          listId: uuidv4(),
          isNew: true,
        };

        push(`${judgmentItemName}.judgmentSubjectData`, newSubjectData);
        setIsOrganizationActive(true);
      }
    }
  }, [formRef, judgmentItemName, organizationToSelect, judgmentOrganizationList]);

  const handleActSelectElement = useCallback(() => {
    if (actToSelect && actToSelect.guid && judgmentItemSubjectDataItemName && !isActActive) {
      // @ts-ignore
      judgmentActList = formRef?.current.getFieldState(
        `${judgmentItemSubjectDataItemName}.cancellationActsAndDecisions` as keyof IKnmErknmForm,
      )?.value;

      if (!judgmentActList?.map(x => x.actGuid).includes(actToSelect.guid) && push) {
        const newActCancellationInformation: IKnmErknmFormJudgmentActsAndDecisions = {
          actGuid: actToSelect.guid,
          decisionGuid: undefined,
          title: `Акт №${actToSelect.numberAct}`,
          cancellationInformation: undefined,
          newCancellationInformation: undefined,
          explanation: undefined,
          newExplanation: undefined,
          isNew: true,
          listId: uuidv4(),
        };

        push(`${judgmentItemSubjectDataItemName}.cancellationActsAndDecisions`, newActCancellationInformation);
        setIsActActive(true);
      }
    }
  }, [formRef, judgmentItemName, actToSelect, judgmentActList]);

  const handleDecisionSelectElement = useCallback(() => {
    if (decisionToSelect && decisionToSelect.guid && judgmentItemSubjectDataItemName && !isDecisionActive) {
      // @ts-ignore
      judgmentDecisionList = formRef?.current.getFieldState(
        `${judgmentItemSubjectDataItemName}.cancellationActsAndDecisions` as keyof IKnmErknmForm,
      )?.value;

      if (!judgmentDecisionList?.map(x => x.decisionGuid).includes(decisionToSelect.guid) && push) {
        const newActCancellationInformation: IKnmErknmFormJudgmentActsAndDecisions = {
          actGuid: undefined,
          decisionGuid: decisionToSelect.guid,
          title: `Решение №${decisionToSelect.numberDecision}`,
          cancellationInformation: undefined,
          newCancellationInformation: undefined,
          explanation: undefined,
          newExplanation: undefined,
          isNew: true,
          listId: uuidv4(),
        };

        push(`${judgmentItemSubjectDataItemName}.cancellationActsAndDecisions`, newActCancellationInformation);
        setIsDecisionActive(true);
      }
    }
  }, [formRef, judgmentItemName, decisionToSelect, judgmentDecisionList]);

  const handleJudgmentSelectElement = useCallback(() => {
    if (judgmentToSelect && judgmentToSelect.guid && !isJudgmentActive) {
      // @ts-ignore
      judgmentCancellationList = formRef?.current.getFieldState(
        `${judgmentItemName}.canceledJudgments` as keyof IKnmErknmForm,
      )?.value;
      if (!judgmentCancellationList?.map(x => x.guid).includes(judgmentToSelect.guid) && push) {
        const newCanceledJudgment: IKnmErknmFormJudgmentCanceled = {
          guid: judgmentToSelect.guid,
          numberJudgment: judgmentToSelect.numberJudgment ? judgmentToSelect.numberJudgment : undefined,
          judgmentSubjectData: judgmentToSelect.judgmentSubjectData,
          listId: uuidv4(),
        };

        push(`${judgmentItemName}.canceledJudgments`, newCanceledJudgment);
        setIsJudgmentActive(true);
      }
    }
  }, [formRef, judgmentItemName, judgmentToSelect, judgmentCancellationList]);

  return (
    <div className={isItemActive()} onClick={handleSelect}>
      {modalType === 'organization' && organizationToSelect && (
        <>
          <Row>
            <div className={styles.InformationContentBlock}>
              {organizationToSelect.inn && (
                <>
                  <div className={isOrganizationActive ? styles.InformationTitleActive : styles.InformationTitle}>
                    ИНН
                  </div>
                  <div className={isOrganizationActive ? styles.InformationTextActive : styles.InformationText}>
                    {organizationToSelect.inn}
                  </div>
                </>
              )}
              {organizationToSelect.ogrn && (
                <>
                  <div className={isOrganizationActive ? styles.InformationTitleActive : styles.InformationTitle}>
                    ОГРН
                  </div>
                  <div className={isOrganizationActive ? styles.InformationTextActive : styles.InformationText}>
                    {organizationToSelect.ogrn}
                  </div>
                </>
              )}
              {organizationToSelect.kpp && (
                <>
                  <div className={isOrganizationActive ? styles.InformationTitleActive : styles.InformationTitle}>
                    КПП
                  </div>
                  <div className={isOrganizationActive ? styles.InformationTextActive : styles.InformationText}>
                    {organizationToSelect.kpp}
                  </div>
                </>
              )}
              {organizationToSelect.rafpNza && (
                <>
                  <div className={isOrganizationActive ? styles.InformationTitleActive : styles.InformationTitle}>
                    НЗА
                  </div>
                  <div className={isOrganizationActive ? styles.InformationTextActive : styles.InformationText}>
                    {organizationToSelect.rafpNza}
                  </div>
                </>
              )}
            </div>
          </Row>
          {organizationToSelect.country?.label && (
            <Row>
              <div className={styles.InformationContentBlock}>
                <div className={isOrganizationActive ? styles.InformationTitleActive : styles.InformationTitle}>
                  Государство, в котором указанное юридическое лицо зарегистрировано
                </div>
                <div className={isOrganizationActive ? styles.InformationTextActive : styles.InformationText}>
                  {organizationToSelect.country?.label}
                </div>
              </div>
            </Row>
          )}
          <Row>
            <div className={isOrganizationActive ? styles.InformationTextActive : styles.InformationText}>
              {organizationToSelect.organizationName}
            </div>
          </Row>
        </>
      )}
      {modalType === 'actsAndDecisions' && (
        <>
          {actToSelect && (
            <>
              <Row>
                <div className={styles.InformationContentBlock}>
                  {actToSelect.numberAct && (
                    <>
                      <div className={isActActive ? styles.InformationTitleActive : styles.InformationTitle}>№</div>
                      <div className={isActActive ? styles.InformationTextActive : styles.InformationText}>
                        {actToSelect.numberAct}
                      </div>
                    </>
                  )}
                  <div className={isActActive ? styles.InformationTitleActive : styles.InformationTitle}>
                    Дата и время составления акта КНМ
                  </div>
                  <div className={isActActive ? styles.InformationTextActive : styles.InformationText}>
                    {actToSelect.creationActDateTime}
                  </div>
                </div>
              </Row>
              <Row>
                <div className={isActActive ? styles.InformationTextActive : styles.InformationText}>
                  {actToSelect.typeAct?.name}
                </div>
              </Row>
            </>
          )}
          {decisionToSelect && (
            <>
              <Row>
                <div className={styles.InformationContentBlock}>
                  <div className={isDecisionActive ? styles.InformationTitleActive : styles.InformationTitle}>№</div>
                  <div className={isDecisionActive ? styles.InformationTextActive : styles.InformationText}>
                    {decisionToSelect.numberDecision}
                  </div>
                  <div className={isDecisionActive ? styles.InformationTitleActive : styles.InformationTitle}>
                    Дата решения
                  </div>
                  <div className={isDecisionActive ? styles.InformationTextActive : styles.InformationText}>
                    {decisionToSelect.dateDecision}
                  </div>
                </div>
              </Row>
              <Row>
                <div className={isDecisionActive ? styles.InformationTextActive : styles.InformationText}>
                  {decisionToSelect.kindDecision?.name}
                </div>
              </Row>
            </>
          )}
        </>
      )}
      {modalType === 'judgments' && judgmentToSelect && (
        <>
          <Row>
            <div className={styles.InformationContentBlock}>
              <div className={isJudgmentActive ? styles.InformationTitleActive : styles.InformationTitle}>№</div>
              <div className={isJudgmentActive ? styles.InformationTextActive : styles.InformationText}>
                {judgmentToSelect.numberJudgment}
              </div>
              <div className={isJudgmentActive ? styles.InformationTitleActive : styles.InformationTitle}>
                Дата судебного решения
              </div>
              <div className={isJudgmentActive ? styles.InformationTextActive : styles.InformationText}>
                {judgmentToSelect.dateJudgment}
              </div>
            </div>
          </Row>
          <Row>
            <div className={isJudgmentActive ? styles.InformationTextActive : styles.InformationText}>
              {judgmentToSelect.judgmentAction}
            </div>
          </Row>
        </>
      )}
    </div>
  );
};

export const JudgmentModalElement = connect(null)(JudgmentModalElementWithoutStore);
